import { BufferUsage } from "../../RenderEngine/RenderEnum/BufferTargetType";
import { DrawType } from "../../RenderEngine/RenderEnum/DrawType";
import { IndexFormat } from "../../RenderEngine/RenderEnum/IndexFormat";
import { RenderCapable } from "../../RenderEngine/RenderEnum/RenderCapable";
import { MeshTopology } from "../../RenderEngine/RenderEnum/RenderPologyMode";
import { VertexDeclaration } from "../../RenderEngine/VertexDeclaration";
import { LayaGL } from "../../layagl/LayaGL";
import { VertexElement } from "../../renders/VertexElement";
import { VertexElementFormat } from "../../renders/VertexElementFormat";
import { Mesh2D } from "../../resource/Mesh2D";
export class SpineMeshUtils {
    static createMesh(type, vbCreator, ibCreator, isDynamic = false, uploadBuffer = true) {
        let mesh = new Mesh2D;
        let vertexBuffers = [];
        let usage = isDynamic ? BufferUsage.Dynamic : BufferUsage.Static;
        let vertexBuffer = LayaGL.renderDeviceFactory.createVertexBuffer(usage);
        let vertexDeclaration = vbCreator.vertexDeclaration;
        let vertexStride = vertexDeclaration.vertexStride;
        vertexBuffer.vertexDeclaration = vertexDeclaration;
        let vbByteLength = vbCreator.maxVertexCount * vertexStride;
        let vbUploadLength = vbCreator.vbLength * Float32Array.BYTES_PER_ELEMENT;
        vertexBuffer.setDataLength(vbByteLength);
        if (uploadBuffer) {
            vertexBuffer.setData(vbCreator.vb.buffer, 0, 0, vbUploadLength);
        }
        vertexBuffers.push(vertexBuffer);
        mesh._vertexCount = vbByteLength / vertexStride;
        mesh._vertexBuffers = vertexBuffers;
        let ibByteLength = ibCreator.maxIndexCount * ibCreator.size;
        let ibUploadLength = ibCreator.ibLength;
        let indexbuffer = LayaGL.renderDeviceFactory.createIndexBuffer(usage);
        indexbuffer.indexType = ibCreator.type;
        indexbuffer.indexCount = ibCreator.maxIndexCount;
        indexbuffer._setIndexDataLength(ibByteLength);
        if (uploadBuffer) {
            indexbuffer._setIndexData(ibCreator.ib, 0);
        }
        mesh._indexBuffer = indexbuffer;
        let state = mesh._bufferState;
        state.applyState(vertexBuffers, indexbuffer);
        let subMeshes = [];
        let multi = ibCreator.outRenderData;
        for (let i = 0, len = multi.renderData.length; i < len; i++) {
            let data = multi.renderData[i];
            let geometry = LayaGL.renderDeviceFactory.createRenderGeometryElement(MeshTopology.Triangles, DrawType.DrawElement);
            geometry.bufferState = state;
            geometry.setDrawElemenParams(data.length, data.offset * ibCreator.size);
            geometry.indexFormat = ibCreator.type;
            subMeshes.push(geometry);
        }
        mesh._setSubMeshes(subMeshes);
        var memorySize = vbByteLength + ibByteLength;
        mesh._setCPUMemory(memorySize);
        mesh._setGPUMemory(memorySize);
        return mesh;
    }
    static createMeshDynamic(vertexDeclaration) {
        let mesh = new Mesh2D;
        let vertexBuffers = [];
        let usage = BufferUsage.Dynamic;
        let vertexBuffer = LayaGL.renderDeviceFactory.createVertexBuffer(usage);
        vertexBuffer.vertexDeclaration = vertexDeclaration;
        vertexBuffers.push(vertexBuffer);
        mesh._vertexBuffers = vertexBuffers;
        let indexbuffer = LayaGL.renderDeviceFactory.createIndexBuffer(usage);
        mesh._indexBuffer = indexbuffer;
        let state = mesh._bufferState;
        state.applyState(vertexBuffers, indexbuffer);
        return mesh;
    }
    static _updateSpineSubMesh(mesh, frameData) {
        let subMeshCount = mesh.subMeshCount;
        let mulitRenderData = frameData.mulitRenderData;
        if (!mulitRenderData)
            return false;
        let renderdata = mulitRenderData.renderData;
        let rdLength = renderdata.length;
        let needUpdate = subMeshCount != rdLength;
        let subMeshes = mesh._subMeshes;
        if (needUpdate) {
            let flen = Math.max(rdLength, subMeshCount);
            let state = mesh._bufferState;
            for (let i = 0; i < flen; i++) {
                let submesh = subMeshes[i];
                let data = renderdata[i];
                if (data) {
                    if (!submesh) {
                        submesh = LayaGL.renderDeviceFactory.createRenderGeometryElement(MeshTopology.Triangles, DrawType.DrawElement);
                        submesh.bufferState = state;
                        subMeshes[i] = submesh;
                    }
                    submesh.indexFormat = frameData.type;
                    submesh.clearRenderParams();
                    submesh.setDrawElemenParams(data.length, data.offset * frameData.size);
                }
                else {
                    submesh.destroy();
                }
            }
            subMeshes.length = rdLength;
        }
        else {
            for (let i = 0; i < subMeshCount; i++) {
                let submesh = subMeshes[i];
                let data = renderdata[i];
                submesh.indexFormat = frameData.type;
                submesh.clearRenderParams();
                submesh.setDrawElemenParams(data.length, data.offset * frameData.size);
            }
        }
        return needUpdate;
    }
    static getVertexDeclaration(vertexFlag) {
        var verDec = SpineMeshUtils._vertexDeclarationMap[vertexFlag];
        if (!verDec) {
            var subFlags = vertexFlag.split(",");
            var elements = [];
            var offset = 0;
            for (var i = 0, n = subFlags.length; i < n; i++) {
                var element;
                switch (subFlags[i]) {
                    case "COLOR2":
                        element = new VertexElement(offset, VertexElementFormat.Vector4, 11);
                        offset += 16;
                        break;
                    case "BONE":
                        element = new VertexElement(offset, VertexElementFormat.Single, 3);
                        elements.push(element);
                        offset += 4;
                        element = new VertexElement(offset, VertexElementFormat.Single, 4);
                        elements.push(element);
                        offset += 4;
                        element = new VertexElement(offset, VertexElementFormat.Vector4, 5);
                        elements.push(element);
                        offset += 16;
                        element = new VertexElement(offset, VertexElementFormat.Vector4, 6);
                        elements.push(element);
                        offset += 16;
                        element = new VertexElement(offset, VertexElementFormat.Vector4, 7);
                        offset += 16;
                        break;
                    case "RIGIDBODY":
                        element = new VertexElement(offset, VertexElementFormat.Single, 4);
                        offset += 4;
                        break;
                    case "UV":
                        element = new VertexElement(offset, VertexElementFormat.Vector2, 0);
                        offset += 8;
                        break;
                    case "COLOR":
                        element = new VertexElement(offset, VertexElementFormat.Vector4, 1);
                        offset += 16;
                        break;
                    case "POSITION":
                        element = new VertexElement(offset, VertexElementFormat.Vector2, 2);
                        offset += 8;
                        break;
                    default:
                        throw "VertexMesh: unknown vertex flag.";
                }
                elements.push(element);
            }
            verDec = new VertexDeclaration(offset, elements);
            SpineMeshUtils._vertexDeclarationMap[vertexFlag] = verDec;
        }
        return verDec;
    }
    static getIndexFormat(vertexCount) {
        let type = IndexFormat.UInt32;
        if (vertexCount < 256 && LayaGL.renderEngine.getCapable(RenderCapable.Element_Index_Uint8)) {
            type = IndexFormat.UInt8;
        }
        else if (vertexCount < 65536) {
            type = IndexFormat.UInt16;
        }
        return type;
    }
}
SpineMeshUtils._vertexDeclarationMap = {};
